import { hqDashboardResultSchema, hqHistoricalReportBodySchema, type HqDashboardQuery } from '@kop/contracts';

function configuration() {
  return {
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? '', apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? '',
    appId: import.meta.env.VITE_FIREBASE_APP_ID ?? '', authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? '',
    appCheckSiteKey: import.meta.env.VITE_FIREBASE_APPCHECK_SITE_KEY ?? '',
  };
}

/** Shared authenticated app; no direct Firestore rules, scan fallback or local persistent copy. */
export async function loadSavedHeadquartersDashboard(uid: string, input: HqDashboardQuery) {
  const config = configuration();
  if (!uid.trim() || import.meta.env.VITE_AUTH_ADAPTER !== 'firebase' || Object.values(config).some(value => !value.trim()))
    throw Error('HQ_DASHBOARD_READ_UNAVAILABLE');
  const { createHqDashboardReadPort } = await import('@kop/operations-firebase-adapter');
  const query = { ...input, includeInspection: true, inspectionBasis: 'halfyear' as const };
  const result = hqDashboardResultSchema.parse(await createHqDashboardReadPort(config, uid).load(query));
  if (result.day !== input.day || result.year !== input.year || result.half !== input.half || result.inspectionBasis !== 'halfyear')
    throw Error('HQ_DASHBOARD_PERIOD_MISMATCH');
  return result;
}

export async function loadSavedHeadquartersReport(uid: string, id: string) {
  const config = configuration();
  if (!uid.trim() || import.meta.env.VITE_AUTH_ADAPTER !== 'firebase' || Object.values(config).some(value => !value.trim()))
    throw Error('HQ_REPORT_READ_UNAVAILABLE');
  const { createHqDashboardReadPort } = await import('@kop/operations-firebase-adapter');
  const value = await createHqDashboardReadPort(config, uid).detail({ id });
  if (!value || typeof value !== 'object' || !('contentHash' in value)) throw Error('HQ_REPORT_RESPONSE_INVALID');
  const { contentHash, ...body } = value as Record<string, unknown>;
  const report = hqHistoricalReportBodySchema.parse(body);
  if (report.id !== id || typeof contentHash !== 'string' || !/^[a-f0-9]{64}$/u.test(contentHash))
    throw Error('HQ_REPORT_RESPONSE_INVALID');
  return report;
}
